<template>
    <div class="home">
        <img alt="Vue logo" src="../assets/logo.png">
        <h1>FHK Qualification/Training DataBank</h1>

        <div v-if="user">
            <h5 v-if="user.displayName">Welcome {{user.displayName}}</h5>
            <h5 v-if="user.jobTitle"> Job Title: {{user.jobTitle}}</h5>
        </div>
        <div v-else>
            <h5>Fail to get your account info. Please try again later.</h5>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {Vue, Component} from 'vue-property-decorator'

    /**
     * Class-component
     */
    @Component
    export default class Home extends Vue {
        user = null;

        mounted() {
            if (Object.keys(this.$store.state.user).length) {
                this.user = this.$store.state.user
            }
        }
    }

</script>
